<template>
  <div class="bg-white">
    <div class="flex justify-center w-full" v-if="loading">
      <Lynx-Spinner size="16" />
    </div>
    <div v-else>
      <p>
        <span class="pr-2 font-bold">Razão Social:</span>
        <span v-text="empresa.razao_social" />
      </p>
      <p>
        <span class="pr-2 font-bold">CNPJ:</span>
        <span v-text="empresa.cnpj" />
      </p>
      <div class="flex gap-3">
        <label class="flex flex-col w-1/3">
          <Lynx-Label label="Mudar etapa empresa" />
          <b-select placeholder="Selecione uma etapa" v-model="status">
            <option
              v-for="(option, key) in lista_status"
              :value="option.id"
              :key="key"
              v-text="option.label"
            />
          </b-select>
        </label>
        <label class="flex flex-col w-1/3">
          <b-switch v-model="gestora" :true-value="1" :false-value="0">
            Liberado para Gestora (Em processo de abertura)
          </b-switch>
        </label>
      </div>

      <div class="flex justify-end pt-2 ">
        <Lynx-Button
          text="salvar"
          class="mb-8"
          icon="Reload"
          @click.native="mudarEtapa"
          size="small"
          icon-size="3"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { empresasShowRequest } from "@/services/requests/empresas";

export default {
  name: "Geral",
  props: ["empresa"],
  data() {
    return {
      loading: false,
      status: null,
      gestora: this.empresa.gestora ?? false,
      lista_status: [
        { id: 1, label: "Processando" },
        { id: 2, label: "Aguardando assinatura" },
        { id: 3, label: "Aguardando certificado" },
        { id: 4, label: "Aguardando CNPJ" },
        { id: 5, label: "Aguardando alvará" },
        { id: 6, label: "Aguardando acesso" },
        { id: 7, label: "Aguardando simples" },
        { id: 8, label: "Aguardando Documentação" },
        { id: 9, label: "Pré-cadastro" },
        { id: 99, label: "Aguardando ativação" },
        { id: 100, label: "Ativo" },
        { id: 101, label: "Comercial (Cliente não responde)" },
      ],
    };
  },
  computed: {
    mensagem_alert() {
      return this.$store.state.empresas.mensagem_alert;
    },
  },
  methods: {
    async mudarEtapa() {
      await this.$store.dispatch("empresas/mudar_status_empresa", {
        status: this.status,
        empresas_id: this.empresa.id,
        gestora: this.gestora
      });

      this.$snack.success(this.mensagem_alert.message);

      //     empresasShowRequest(this.empresa.id)
      // .then(res => {
      //   this.setEmpresa(res.data.data)
      //   this.$router.push({name: 'empresas.show'})
      // })
      // .catch(() => this.$snack.error('Empresa não encontrada'))
      // .finally(() => bus.globalLoading = false)
    },
  },
};
</script>

<style scoped>
</style>
